import React from 'react';

export const LockInputIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.81787 9C3.40366 9 3.06787 9.33579 3.06787 9.75V15C3.06787 15.4142 3.40366 15.75 3.81787 15.75H14.3179C14.7321 15.75 15.0679 15.4142 15.0679 15V9.75C15.0679 9.33579 14.7321 9 14.3179 9H3.81787ZM1.56787 9.75C1.56787 8.50736 2.57523 7.5 3.81787 7.5H14.3179C15.5605 7.5 16.5679 8.50736 16.5679 9.75V15C16.5679 16.2426 15.5605 17.25 14.3179 17.25H3.81787C2.57523 17.25 1.56787 16.2426 1.56787 15V9.75Z"
      fill="var(--color-text-muted)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.06787 2.25C8.27222 2.25 7.50916 2.56607 6.94655 3.12868C6.38394 3.69129 6.06787 4.45435 6.06787 5.25V8.25C6.06787 8.66421 5.73208 9 5.31787 9C4.90366 9 4.56787 8.66421 4.56787 8.25V5.25C4.56787 4.05653 5.04198 2.91193 5.88589 2.06802C6.7298 1.22411 7.8744 0.75 9.06787 0.75C10.2613 0.75 11.4059 1.22411 12.2498 2.06802C13.0938 2.91193 13.5679 4.05653 13.5679 5.25V8.25C13.5679 8.66421 13.2321 9 12.8179 9C12.4037 9 12.0679 8.66421 12.0679 8.25V5.25C12.0679 4.45435 11.7518 3.69129 11.1892 3.12868C10.6266 2.56607 9.86352 2.25 9.06787 2.25Z"
      fill="var(--color-text-muted)"
    />
  </svg>
);
